import { useEffect } from "react";
import { useQueryString } from "../../hooks";
import { View } from "./View";

// DESCRIPTION: This component handles the redirect that happens (INISIDE the IFrame) from PGw => SwApp
// It then informs the parent window (that opened it) to redirect to merchant  => MerchantPage
// NOTE: This should keep querying the endpoint for the tx status while displaying a loading icon

// method 2: upon redirect, send message of completion to parent(<TransactionIFrame />) and
//     close IFramePaymentRedirectHandler immediately. This PASSES CONTROL back to TransactionIFrame
//     <TransactionIFrame /> then performs <method 1> and can then successfully redirect to merchantPage successfully
export const IFramePaymentRedirectHandler = () => {
  const query = useQueryString();
  const gatewayTxStatus = query.get("status");
  const gatewayTxRef = query.get("tx_ref");
  const merchantRedirect = query.get("merchant_redirect_url");

  // console.log("full url: ", window.location.href);

  useEffect(() => {
    const messageFromQueryString = {
      channel: "switchAppRedirectMessage",
      tx_ref: gatewayTxRef,
      status: gatewayTxStatus,
      merchant_redirect_url: merchantRedirect,
    };

    window.parent.postMessage(messageFromQueryString, "/");
  }, []);

  return <View />;
};
